function e(t) {
  return typeof t != "string" ? [] : t.split(".");
}
export {
  e as getSplittedPath
};
